import React from "react";
import ReactDOM from "react-dom";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import "assets/scss/argon-design-system-react.scss?v1.1.0";
import "assets/scss/custom.scss?v1.0";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Provider } from "react-redux";
import App from "./app";
import store from "./store.js";
import "antd/dist/antd.css";
import "./styles/style.scss";
import { HelperProvider } from "store/helperStore";
import { AllTestProvider } from "store/allTestStore";
import { AllReportedProvider } from "./store/allReportedStore";

import axios from "axios";

const globalState = store.getState().globaReducer;
axios.defaults.baseURL = globalState.host;

ReactDOM.render(
  <Provider store={store}>
    <HelperProvider>
      <AllTestProvider>
        <AllReportedProvider>
          <App />
        </AllReportedProvider>
      </AllTestProvider>
    </HelperProvider>
  </Provider>,
  document.getElementById("root")
);
